<template>
  <v-row>
    <v-col>
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="computedDateFormatted"
            :label="label"
            hint="วว/ดด/ปปปป"
            persistent-hint
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :value="dateTH"
          ></v-text-field>
        </template>
        <v-date-picker no-title @change="dateTHChange" locale="th-th"></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    dateFormatted: null,
    menu2: false,
  }),
  props: {
    dateTH: { type: String, default: new Date().toISOString().substr(0, 10) },
    label: { type: String, default: "" },
  },
  computed: {
    computedDateFormatted() {
      return this.dateFormatted || this.formatDate(this.dateTH);
    },
  },

  methods: {
    formatDate(date) {
      if (!date) {
        return null;
      } else {
        this.$emit("callBackValue", date);
        const [year, month, day] = date.split("-");
        return `${day}/${month}/` + (parseInt(year) + 543).toString();
      }
    },
    dateTHChange(val) {
      // console.log(val);
      this.menu2 = false;
      this.dateFormatted = this.formatDate(val);
    },
  },
};
</script>
